import { SLUG_SPORTS } from '~/constants'
export const athenaGames = [
  {
    name: 'a-sports',
    id: SLUG_SPORTS.A_SPORTS
  },
  {
    name: 'E sports',
    id: SLUG_SPORTS.E_SPORTS
  },
  {
    name: 'Virtual sport',
    id: SLUG_SPORTS.V_SPORTS
  },
  {
    name: 'keno',
    id: 'keno'
  },
  {
    name: 'TP Number game',
    id: 'tp-numbergame'
  },
  {
    name: 'number-game',
    id: 'number-game'
  },
  {
    name: 'virtual games',
    id: 'virtualgame'
  },
  {
    name: 'Saba club',
    id: 'saba-club'
  },
  {
    name: 'lottery-cyber-punk',
    id: 'lottery-cyber-punk'
  },
  {
    name: 'Quay so Disco',
    id: 'quayso-disco'
  },
  {
    name: 'v-gaming',
    id: '58239'
  },
  {
    name: 'numbers game saba',
    id: '32751'
  },
  {
    name: 'keno Saba',
    id: '57270'
  },
  {
    name: 'parlay 5',
    id: '57452'
  },
  {
    name: 'turbo',
    id: '57450'
  },
  {
    name: 'soccer',
    id: '57448'
  },
  {
    name: 'happy 5',
    id: '57446'
  },
  {
    name: 'Saba Table Games',
    id: 'tablegame'
  },
  {
    name: 'lottery',
    id: '57277'
  }
]
